<mat-chip-set>
  @if (groupsLoading) {
    <mat-chip> Loading ... </mat-chip>
  } @else {
    @for (group of selectedGroups; track $index) {
      <mat-chip [removable]="true" (removed)="removeGroup($index)">
        {{ group?.name }}
        <button matChipRemove [attr.aria-label]="'Remove ' + group?.name" [tabIndex]="0">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>
    } @empty {
      <mat-chip>
        {{ 'Integrations.Weather.Custom.SelectedGroupsNone' | translate: locale.language }}
      </mat-chip>
    }
  }
</mat-chip-set>
<div style="margin-top: 15px">
  <button mat-raised-button (click)="selectGroups()">
    <mat-icon>add</mat-icon>
    {{ 'Integrations.Weather.Custom.SelectGroupsAdd' | translate: locale.language }}
  </button>
</div>
